import { FC, ReactNode } from "react";
import { clsx } from "clsx";
import { SvgIcon } from "./SvgIcon";
import styles from "./EditableField.module.less";

export interface EditableFieldProps {
    /** False shows the value as it is, with no affordance. */
    canEdit: boolean;
    /** What starts the edit (an input, a picker...). Omit when a popover around the field handles the click. */
    onClick?: () => void;
    /** Span the whole cell, the edit icon at its far edge, rather than fit the value. */
    fill?: boolean;
    children: ReactNode;
    className?: string;
}

/**
 * A value the user may edit in place: when editable, hovering tints it blue
 * and reveals an edit icon, and clicking starts the edit. The tint bleeds
 * into the gutter on the left so the value stays flush with its label.
 */
export const EditableField: FC<EditableFieldProps> = ({ canEdit, onClick, fill, children, className }) => (
    <span
        className={clsx(
            styles.field,
            canEdit && styles["field--editable"],
            fill && styles["field--fill"],
            className
        )}
        onClick={canEdit ? onClick : undefined}
    >
        {children}
        {canEdit && <SvgIcon name="edit" size={12} className={styles.icon} />}
    </span>
);
